import styled from 'styled-components';
import { COLORS } from 'constants/design';

const Container = styled.div`
  .recap {
    background: transparent
      linear-gradient(229deg, #707891 0%, #0b7cc5 0%, #56afbb 88%, #5db4ba 100%)
      0% 0% no-repeat padding-box;
    opacity: 1;
    width: 46px;
    height: 46px;
    border-radius: 300px;
    justify-content: center;
    display: flex;
    align-items: center;
  }
  .titleContainer {
    display: flex;
  }
  .recapValue {
    font-family: Roboto;
    font-weight: Bold;
    font-size: 18px;
    letter-spacing: 0;
    color: ${COLORS.WHITE};
    opacity: 1;
  }
  .title {
    text-align: left;
    font-family: Roboto;
    font-weight: Bold;
    font-size: 18px;
    letter-spacing: 0;
    color: #384264;
    opacity: 1;
    padding: 10px;
  }
`;

export interface CardTitleProps {
  count?: number;
  message: string;
}

const CardTitle = (props: CardTitleProps) => {
  const { count, message } = props;
  return (
    <Container>
      <div className="titleContainer">
        {count ? (
          count >= 0 && (
            <div className="recap">
              <span className="recapValue" data-testid="count">
                {count}
              </span>
            </div>
          )
        ) : (
          <></>
        )}
        <span className="title">{message}</span>
      </div>
    </Container>
  );
};

export default CardTitle;
